import { NAME_APP, modules } from '@/constants';
import { defineStore } from 'pinia';
// eslint-disable-next-line import/no-cycle
import router from '@/router/index';
// eslint-disable-next-line import/no-cycle
import Api from '~utils/Api';
import { setCookie, deleteCookie, getCookie } from '~utils/cookies';
import { clearTreeState } from '~utils/statePersistence';
import { ConstantParams } from '../types';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '../index';
import { User, UserData, UserRole } from './types';

// const api = new Api();
const DEFAULT_RANG = 1;
const DEFAULT_ROLE = 27;
const DAYS = 1;

export const useAuthStore = defineStore('auth', {
  state: () => ({
    isAuth: false,
    IMEI: '',
    user: {} as User,
  }),

  getters: {
    getIsAuth: (state) => state.isAuth,
    currentUser: (state) => state.user,
    currentUserId: (state) => state.user.id_login,
    userName: (state) => state.user.vrach_fio || '',
    userRang: (state) => state.user.rang,
  },

  actions: {
    async getImei() {
      this.IMEI = await Api.getImei();
    },

    async signIn(login: string, password: string): Promise<void> {
      if (!this.IMEI) {
        await this.getImei();
      }
      const params = {
        login,
        password,
        IMEI: this.IMEI,
        Name_app: NAME_APP,
      };
      try {
        const result = await Api.login(params);
        if (result) {
          this.user = <User><unknown>result;
          console.log(this.user);
          const constantParams: ConstantParams = {
            IMEI: this.IMEI,
            Name_app: NAME_APP,
            TK: this.user.TK,
            id_login: this.user.id_login,
          };
          setCookie('id_login', `${this.user.id_login}`, { secure: true, expires: DAYS });
          setCookie('TK', this.user.TK, { secure: true, expires: DAYS });
          useMainStore().setConstantParams(constantParams);
          this.isAuth = true;
          this.autenticate();
          router.push({ name: 'Dashboard' });
        }
      } catch (error) {
        console.log(error);
      }
    },

    checkAuth() {
      const storedUserData: UserData = {
        id_login: Number(getCookie('id_login')) || 0,
        TK: getCookie('TK') || '',
      };
      if (storedUserData.id_login && storedUserData.TK) {
        return storedUserData;
      }
      return false;
    },

    async autenticate(): Promise<void> {
      if (!this.IMEI) {
        // this.IMEI = getCookie('IMEI') || '';
        await this.getImei();
      }
      const userData: UserData | boolean = this.checkAuth();
      if (!userData) {
        return;
      }
      const params = {
        ...userData,
        IMEI: this.IMEI,
        Name_app: NAME_APP,
        Name_event: 'GET:user_data',
        Name_module: modules.webmanagers,
        TK: userData.TK,
        id_login: userData.id_login,
      };
      const result = await Api.get(params);
      if (!result.errorType && result.data) {
        [this.user] = result.data as User[];
        const constantParams: ConstantParams = {
          IMEI: this.IMEI,
          Name_app: NAME_APP,
          TK: userData.TK,
          id_login: this.user.id_login,
        };
        if (this.user.role_list) {
          const permissionScheme = JSON.parse(this.user.role_list);
          const maxRangObject = permissionScheme.reduce(
            (max: UserRole, current: UserRole) => (current.rang > max.rang ? current : max),
          );
          this.user.rang = maxRangObject.rang;
          this.user.role = maxRangObject.role;
        } else {
          this.user.rang = DEFAULT_RANG;
          this.user.role = DEFAULT_ROLE;
        }
        useMainStore().setConstantParams(constantParams);
        this.isAuth = true;
      }
    },

    async logout(): Promise<void> {
      clearTreeState(Number(getCookie('id_login')));
      this.isAuth = false;
      this.user = <User><unknown>{};
      deleteCookie('id_login');
      deleteCookie('TK');
      router.push({ name: 'Login' });
    },
  },
});
